/**
 * @module experience/shop/product-details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const PRODUCT_DETAILS_CONST = {
  NEW: 'new',
  NEW_PRODUCT: 'newProduct',
  REFURBISHED_PRODUCT: 'refurbishedProduct',
  PRODUCTDETAILS_MODULE_NAME: 'ProductDetailsModule',
  PRODUCTDETAILS_SERVICE: 'ProductDetailsService',
  DEVICEDETAILS_COMPONENT: 'DeviceDetailsLandingComponent',
  WARRANTY: 'WARRANTY',
  DETAILS: 'details',
  LANDING: 'landing',
  REVIEW_PDP_LIMIT: 4,
  REVIEW_ALL_LIMIT: 8,
  PRODUCT_DETAILS: '/product-details/',
  NETWORK_CAPABILITY: 'Network Capability',
  FREQUENCIES: 'Frequencies',
  TRUE: 'true',
};

export const PRODUCT_SPECIFICATION_CONST = {
  NETWORK_CAPABILITY: 'Network Capability',
  FREQUENCIES: 'Frequencies',
  TRUE: 'true',
};
